"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return initAdminFromEnv;
    }
});
const _util = require("util");
const _uuid = require("uuid");
const _bcryptjs = /*#__PURE__*/ _interop_require_default(require("bcryptjs"));
const _nocodbsdk = require("nocodb-sdk");
const _boxen = /*#__PURE__*/ _interop_require_default(require("boxen"));
const _isEmail = /*#__PURE__*/ _interop_require_default(require("validator/lib/isEmail"));
const _verifyDefaultWorkspace = require("~/helpers/verifyDefaultWorkspace");
const _utils = require("~/utils");
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _models = require("~/models");
const _globals = require("~/utils/globals");
const _helpers = require("~/services/users/helpers");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const rolesLevel = {
    owner: 0,
    creator: 1,
    editor: 2,
    commenter: 3,
    viewer: 4
};
async function initAdminFromEnv(_ncMeta = _Noco.default.ncMeta) {
    if (process.env.NC_ADMIN_EMAIL && process.env.NC_ADMIN_PASSWORD) {
        var _process_env_NC_ADMIN_EMAIL;
        if (!(0, _isEmail.default)((_process_env_NC_ADMIN_EMAIL = process.env.NC_ADMIN_EMAIL) == null ? void 0 : _process_env_NC_ADMIN_EMAIL.trim())) {
            console.log('\n', (0, _boxen.default)(`Provided admin email '${process.env.NC_ADMIN_EMAIL}'  is not valid`, {
                title: 'Invalid admin email',
                padding: 1,
                borderStyle: 'double',
                titleAlignment: 'center',
                borderColor: 'red'
            }), '\n');
            process.exit(1);
        }
        const { valid, error, hint } = (0, _nocodbsdk.validatePassword)(process.env.NC_ADMIN_PASSWORD);
        if (!valid) {
            console.log('\n', (0, _boxen.default)(`${error}${hint ? `\n\n${hint}` : ''}`, {
                title: 'Invalid admin password',
                padding: 1,
                borderStyle: 'double',
                titleAlignment: 'center',
                borderColor: 'red'
            }), '\n');
            process.exit(1);
        }
        let ncMeta;
        try {
            ncMeta = await _ncMeta.startTransaction();
            const email = process.env.NC_ADMIN_EMAIL.toLowerCase().trim();
            const salt = await (0, _util.promisify)(_bcryptjs.default.genSalt)(10);
            const password = await (0, _util.promisify)(_bcryptjs.default.hash)(process.env.NC_ADMIN_PASSWORD, salt);
            const email_verification_token = (0, _uuid.v4)();
            const roles = 'org-level-creator,super';
            // if super admin not present
            if (await _models.User.isFirst(ncMeta)) {
                // roles = 'owner,creator,editor'
                _utils.T.emit('evt', {
                    evt_type: 'base:invite',
                    count: 1
                });
                const user = await _models.User.insert({
                    email,
                    salt,
                    password,
                    email_verification_token,
                    token_version: (0, _helpers.randomTokenString)(),
                    roles
                }, ncMeta);
                await (0, _verifyDefaultWorkspace.verifyDefaultWorkspace)(user, ncMeta);
            } else {
                const salt = await (0, _util.promisify)(_bcryptjs.default.genSalt)(10);
                const password = await (0, _util.promisify)(_bcryptjs.default.hash)(process.env.NC_ADMIN_PASSWORD, salt);
                const email_verification_token = (0, _uuid.v4)();
                // TODO improve this
                const superUsers = await ncMeta.metaList2(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.USERS);
                let superUserPresent = false;
                for (const user of superUsers){
                    var _user_roles;
                    if (!((_user_roles = user.roles) == null ? void 0 : _user_roles.includes('super'))) continue;
                    superUserPresent = true;
                    if (email !== user.email) {
                        // update admin email and password and migrate bases
                        // if user already present and associated with some base
                        // check user account already present with the new admin email
                        const existingUserWithNewEmail = await _models.User.getByEmail(email, ncMeta);
                        if (existingUserWithNewEmail == null ? void 0 : existingUserWithNewEmail.id) {
                            // get all base access belongs to the existing account
                            // and migrate to the admin account
                            const existingUserProjects = await ncMeta.knexConnection(_globals.MetaTable.PROJECT_USERS).where({
                                fk_user_id: existingUserWithNewEmail.id
                            });
                            for (const existingUserProject of existingUserProjects){
                                const userProject = await _models.BaseUser.get(existingUserProject.base_id, user.id, ncMeta);
                                // if admin user already have access to the base
                                // then update role based on the highest access level
                                if (userProject) {
                                    if (rolesLevel[userProject.roles] > rolesLevel[existingUserProject.roles]) {
                                        await _models.BaseUser.update({
                                            workspace_id: existingUserProject.workspace_id,
                                            base_id: existingUserProject.base_id
                                        }, userProject.base_id, user.id, existingUserProject.roles, ncMeta);
                                    }
                                } else {
                                    // if super doesn't have access then add the access
                                    await _models.BaseUser.insert(_extends({}, existingUserProject, {
                                        fk_user_id: user.id
                                    }), ncMeta);
                                }
                                // delete the old base access entry from DB
                                await _models.BaseUser.delete(existingUserProject.base_id, existingUserProject.fk_user_id, ncMeta);
                            }
                            // delete existing user
                            await ncMeta.metaDelete(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.USERS, existingUserWithNewEmail.id);
                            await _NocoCache.default.del('root', `${_globals.CacheScope.USER}:${existingUserWithNewEmail.id}`);
                            await _NocoCache.default.del('root', `${_globals.CacheScope.USER}:${existingUserWithNewEmail.email}`);
                            // Update email and password of super admin account
                            await _models.User.update(user.id, {
                                salt,
                                email,
                                password,
                                email_verification_token,
                                token_version: (0, _helpers.randomTokenString)()
                            }, ncMeta);
                        } else {
                            // if no user present with the new admin email update the email and password
                            await _models.User.update(user.id, {
                                salt,
                                email,
                                password,
                                email_verification_token,
                                token_version: (0, _helpers.randomTokenString)()
                            }, ncMeta);
                        }
                    } else {
                        const newPasswordHash = await (0, _util.promisify)(_bcryptjs.default.hash)(process.env.NC_ADMIN_PASSWORD, user.salt);
                        if (newPasswordHash !== user.password) {
                            // if email's are same and passwords are different
                            // then update the password and token version
                            await _models.User.update(user.id, {
                                salt,
                                password,
                                email_verification_token,
                                token_version: (0, _helpers.randomTokenString)()
                            }, ncMeta);
                        }
                    }
                }
                if (!superUserPresent) {
                    // check user account already present with the new admin email
                    const existingUserWithNewEmail = await _models.User.getByEmail(email, ncMeta);
                    if (existingUserWithNewEmail == null ? void 0 : existingUserWithNewEmail.id) {
                        await _NocoCache.default.del('root', `${_globals.CacheScope.USER}:${existingUserWithNewEmail.id}`);
                        await _NocoCache.default.del('root', `${_globals.CacheScope.USER}:${existingUserWithNewEmail.email}`);
                        // Update password and roles of existing user
                        await _models.User.update(existingUserWithNewEmail.id, {
                            salt,
                            email,
                            password,
                            email_verification_token,
                            token_version: (0, _helpers.randomTokenString)(),
                            roles
                        }, ncMeta);
                    } else {
                        // no super user present and no user present with the new admin email
                        _utils.T.emit('evt', {
                            evt_type: 'base:invite',
                            count: 1
                        });
                        await _models.User.insert({
                            email,
                            salt,
                            password,
                            email_verification_token,
                            token_version: (0, _helpers.randomTokenString)(),
                            roles
                        }, ncMeta);
                    }
                }
                await (0, _verifyDefaultWorkspace.verifyDefaultWsOwner)(ncMeta);
            }
            await ncMeta.commit();
        } catch (e) {
            console.log('Error occurred while updating/creating admin user');
            await ncMeta.rollback(e);
            throw e;
        }
    }
}
